import React from "react";
import { Container, Grid, Paper, makeStyles, Box } from "@material-ui/core";

import Layout from "../../components/layout";
import Copyright from "../../components/footer/copyright";
import CreateCompany from "../../components/company/create";
import { useClose } from "../../hooks";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

const CreateCompanyPage = () => {
  useClose();
  const classes = useStyles();

  return (
    <Layout>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <CreateCompany />
            </Paper>
          </Grid>
        </Grid>
        <Box pt={4}>
          <Copyright />
        </Box>
      </Container>
    </Layout>
  );
};

export default CreateCompanyPage;
